import { tw } from "@careinfo/tailwind";
import React from "react";
import { cn } from "../../../lib/utils";

export const DropdownCategoryTitle = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div
      className={tw`text-[.65rem] font-semibold mb-1 uppercase text-neutral-500 px-1.5`}
    >
      {children}
    </div>
  );
};

// This is drop down children
export const DropdownButton = React.forwardRef<
  HTMLButtonElement,
  {
    children: React.ReactNode;
    isActive?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
  }
>(function DropdownButtonInner(
  { children, isActive, onClick, disabled, className },
  ref
) {
  const buttonClass = cn(
    "flex items-center gap-2 p-1.5 text-sm font-medium text-neutral-500 bg-primary-light text-left bg-transparent w-full rounded",
    !isActive && !disabled,
    "hover:bg-neutral-100 hover:text-neutral-800",
    isActive &&
      !disabled &&
      "bg-neutral-100 text-text-primary bg-primary-light",
    disabled && "text-neutral-400 cursor-not-allowed",
    className
  );

  return (
    <button
      className={tw`${buttonClass}`}
      disabled={disabled}
      onClick={onClick}
      ref={ref}
      type="button"
    >
      {children}
    </button>
  );
});
